import { render, staticRenderFns } from "./CSignUpStaticAlert.vue?vue&type=template&id=7c955712&scoped=true&"
import script from "./CSignUpStaticAlert.vue?vue&type=script&lang=ts&"
export * from "./CSignUpStaticAlert.vue?vue&type=script&lang=ts&"
import style0 from "./CSignUpStaticAlert.vue?vue&type=style&index=0&id=7c955712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c955712",
  null
  
)

export default component.exports